import * as SpecialEquipment from './components/SpecialEquipment.css';

export default {
	SpecialEquipment
};
